(() => {
  const holidays = [
    '2026-01-01',
    '2026-04-03',
    '2026-04-06',
    '2026-05-01',
    '2026-05-14',
    '2026-05-25',
    '2026-06-04',
    '2026-10-03',
    '2026-12-25',
    '2026-12-26',
    '2027-01-01',
    '2027-03-26',
    '2027-03-29',
    '2027-05-06',
    '2027-05-17',
    '2027-10-03',
    '2027-12-25',
    '2027-12-26',
  ];

  const toDateValue = (date) =>
    [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join(
      '-'
    );

  // Parsing "YYYY-MM-DD" with new Date(value) would read it as UTC and can shift the weekday.
  const weekdayOf = (value) => {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day).getDay();
  };

  const parseDays = (value) => (value ? value.split(',').map(Number) : null);

  const setVisible = (element, visible) => {
    if (element) element.style.display = visible ? 'block' : 'none';
  };

  const restrictTimes = (select, weekday) => {
    [...select.options].forEach((option) => {
      const days = parseDays(option.dataset.days);
      const available = !days || weekday === null || days.includes(weekday);
      option.hidden = !available;
      option.disabled = !available;
    });
    if (select.selectedOptions[0]?.disabled) select.value = '';
  };

  const setMinDates = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    document.querySelectorAll('[data-consultation-form] input[type="date"]').forEach((input) => {
      input.min = toDateValue(tomorrow);
    });
  };

  const handleDateChange = (dateInput) => {
    const form = dateInput.closest('[data-consultation-form]');
    const timeSelect = dateInput.closest('[data-consultation="slot"]').querySelector('select');
    if (!dateInput.value) {
      restrictTimes(timeSelect, null);
      return;
    }
    const weekday = weekdayOf(dateInput.value);
    const valid = parseDays(form.dataset.days).includes(weekday) && !holidays.includes(dateInput.value);
    setVisible(form.querySelector('[data-consultation="date-error"]'), !valid);
    if (!valid) dateInput.value = '';
    restrictTimes(timeSelect, valid ? weekday : null);
  };

  const submit = async (form) => {
    const submitError = form.querySelector('[data-consultation="submit-error"]');
    const submitButton = form.querySelector('[type="submit"]');
    setVisible(submitError, false);
    submitButton.disabled = true;

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error(`Basin responded with ${response.status}`);
      form.style.display = 'none';
      setVisible(form.parentElement.querySelector('[data-consultation="success"]'), true);
    } catch (error) {
      console.error('[consultation] submit failed', error);
      setVisible(submitError, true);
    } finally {
      submitButton.disabled = false;
    }
  };

  // Delegated on document because a colorway change re-renders the section and replaces the forms.
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-consultation="slot"] input[type="date"]')) handleDateChange(event.target);
  });

  document.addEventListener('submit', (event) => {
    if (!event.target.matches('[data-consultation-form]')) return;
    event.preventDefault();
    submit(event.target);
  });

  document.addEventListener('liquify:custom-rendered', setMinDates);
  setMinDates();
})();
